import { Controller } from "@hotwired/stimulus"

// Holds a skeleton in an image's slot until the image has actually painted.
//
// The slot itself is sized by Bootstrap's .ratio, so nothing reflows either
// way — this is about what fills that reserved space while an ActiveStorage
// variant is still resolving, which can take a moment the first time a variant
// is requested.
export default class extends Controller {
  static targets = ["placeholder", "image"]

  connect() {
    if (!this.hasImageTarget) return

    // A cached image can already be complete before Stimulus connects, in
    // which case no load event is coming.
    if (this.imageTarget.complete) {
      this.reveal()
      return
    }

    // On error too: a variant that fails to resolve should fall back to the
    // empty band rather than shimmer forever.
    this.imageTarget.addEventListener("load", () => this.reveal(), { once: true })
    this.imageTarget.addEventListener("error", () => this.reveal(), { once: true })
  }

  reveal() {
    this.placeholderTargets.forEach((element) => element.classList.add("d-none"))
  }
}
